    
    <ng-content></ng-content>
    <p *ngIf="!content">{{errorMessage}}</p>